import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonComponent } from '../../components/button/button.component';
import { ButtonTypeEnum } from '../../components/button/types/button-type.enum';
import { ButtonSizeEnum } from '../../components/button/types/button-size.enum';
import { ButtonRadiusEnum } from '../../components/button/types/button-radius.enum';

export interface ConfirmModalButton {
  id: string;
  label: string;
  type?: ButtonTypeEnum;
  size?: ButtonSizeEnum;
  radius?: ButtonRadiusEnum;
  outline?: boolean;
  disabled?: boolean;
  closeOnClick?: boolean;
  payload?: unknown;
}

export interface ConfirmModalData {
  title?: string;
  description?: string;
  showDivider?: boolean;
  buttons?: ConfirmModalButton[];
}

export interface ConfirmModalResult {
  actionId: string;
  payload?: unknown;
}

@Component({
  selector: 'l-confirm-modal',
  standalone: true,
  templateUrl: './confirm-modal.component.html',
  imports: [ButtonComponent],
})
export class ConfirmModalComponent {

  constructor(
    private readonly ref: DynamicDialogRef,
    private readonly config: DynamicDialogConfig<ConfirmModalData>,
  ) {}

  public readonly buttonTypeEnum = ButtonTypeEnum;

  public readonly buttonSizeEnum = ButtonSizeEnum;

  public readonly buttonRadiusEnum = ButtonRadiusEnum;

  public get title(): string {
    return this.config.data?.title ?? 'Confirmação';
  }

  public get description(): string {
    return this.config.data?.description ?? '';
  }

  public get showDivider(): boolean {
    return this.config.data?.showDivider ?? true;
  }

  public get buttons(): ConfirmModalButton[] {
    return this.config.data?.buttons ?? [
      {
        id: 'cancel',
        label: 'Cancelar',
        type: ButtonTypeEnum.OUTLINE,
        outline: true,
      },
      {
        id: 'confirm',
        label: 'Confirmar',
        type: ButtonTypeEnum.PRIMARY,
      },
    ];
  }

  public handleButtonClick(button: ConfirmModalButton): void {
    if (button.disabled || button.closeOnClick === false) {
      return;
    }

    this.ref.close({
      actionId: button.id,
      payload: button.payload,
    } satisfies ConfirmModalResult);
  }

}